import React, { createContext, useContext } from 'react';
import { useFeatureFlags } from './hook';
import { STATUS } from './constants';
import { State } from './types';
import { useCurrentUserCtx } from '../CurrentUser';

const initialState = {
  state: {
    error: null,
    status: STATUS.IDLE,
    featureFlags: undefined,
  },
  handleSetFeatureFlags: () => {},
  resetFeatureFlags: () => {},
};

type ProviderValue = {
  state: State;
  handleSetFeatureFlags: () => void;
  resetFeatureFlags: () => void;
};

const FeatureFlagsContext = createContext<ProviderValue>(initialState);

export const useFeatureFlagsCtx = () => useContext(FeatureFlagsContext);
export const FeatureFlagsProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const {
    state: { userId },
  } = useCurrentUserCtx();
  const { state, handleSetFeatureFlags, resetFeatureFlags } = useFeatureFlags(
    userId
  );
  return (
    <FeatureFlagsContext.Provider
      value={{
        state,
        handleSetFeatureFlags,
        resetFeatureFlags,
      }}
    >
      {children}
    </FeatureFlagsContext.Provider>
  );
};
